import { ORDER_ST_APPROVAL_API_URL } from "../components/Shared/constant";

const OrderStApproval = async (payload, accessToken) => {
    const responce = window.axios.post(ORDER_ST_APPROVAL_API_URL, payload, {
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Authorization': 'Bearer ' + accessToken,
    }}).then(function (result) {
        return {
          ...result.data,
          status:200
        };
    }).catch(function (result) {
        return {
          ...result?.response?.data,
          status:result?.response?.status
        }
    });
    return responce;
};
  
export default OrderStApproval;